module.exports = __webpack_public_path__ + "static/COMPREHENSIVE_HR_SUPPORT-f3889026506348130def81ca1937f067.png";